import type { Metric } from 'web-vitals';
import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

import { pushDataLayerEvent } from './dataLayer';

const sendWebVital = (metric: Metric): void => {
  // CLS is a unitless fraction; scale so GA integer metrics stay usable.
  const value =
    metric.name === 'CLS'
      ? Math.round(metric.value * 1000)
      : Math.round(metric.value);

  pushDataLayerEvent({
    event: 'web_vitals',
    event_category: 'Web Vitals',
    event_label: metric.id,
    value,
    metric_id: metric.id,
    metric_name: metric.name,
    metric_value: metric.value,
    metric_delta: metric.delta,
    metric_rating: metric.rating,
    page_path: `${window.location.pathname}${window.location.search}`,
    page_location: window.location.href,
    page_title: document.title,
  });
};

let hasStartedReporting = false;

export const reportWebVitals = (): void => {
  if (hasStartedReporting) return;
  hasStartedReporting = true;

  onCLS(sendWebVital);
  onINP(sendWebVital);
  onLCP(sendWebVital);
  onFCP(sendWebVital);
  onTTFB(sendWebVital);
};
